export const checkMediaRecorderSupport = () => {
	if (typeof MediaRecorder === 'undefined') {
		console.error('MediaRecorder is not supported in this environment.');
		return false;
	}
	return true;
};

export const getSupportedMimeType = () => {
	if (!checkMediaRecorderSupport()) return {};

	if (MediaRecorder.isTypeSupported('video/webm; codecs=vp8,opus')) {
		return { mimeType: 'video/webm; codecs=vp8,opus' }; // Default to WebM
	} else if (MediaRecorder.isTypeSupported('video/mp4; codecs=avc1.42E01E, mp4a.40.2')) {
		return { mimeType: 'video/mp4; codecs=avc1.42E01E, mp4a.40.2' }; // Safari fallback to MP4
	} else {
		return {}; // Let the browser choose if no preferred format is supported
	}
};

export const getExtensionFromRecorderMimeType = () => {
	const mimeType = getSupportedMimeType();
	return mimeType.mimeType && mimeType.mimeType.includes('mp4') ? 'mp4' : 'webm';
};
